// @flow

import { FormattedMessage } from 'react-intl'
import React from 'react'
import styled from 'styled-components'

import { theme } from '../../constants/theme'
import { variantColorMap } from '../../constants/variants'

const createTypography = (initFontSize) => ({
  tradId, className = '', variant, bold = false, upper = false,
  block = false, children, values, underlined, fontSize = initFontSize, ...rest
}) => {
  if (tradId) {
    return (
      <FormattedMessage id={tradId} values={values}>
        {
          (m) => (
            <Message
              block={block}
              size={fontSize}
              upper={upper}
              bold={bold}
              variant={variant}
              underlined={underlined}
              className={className}
              {...rest}
            >
              {m}
              {children}
            </Message>
          )
        }
      </FormattedMessage>
    )
  }

  return (
    <Message
      block={block}
      size={fontSize}
      upper={upper}
      bold={bold}
      variant={variant}
      className={className}
      underlined={underlined}
      {...rest}
    >
      {children}
    </Message>
  )
}
const Message = styled.span`
  color: ${({ variant }) => variantColorMap[variant]};
  font-size: ${({ size }) => size};
  font-weight: ${({ bold }) => (bold ? 700 : 400)};
  ${({ upper }) => (upper ? 'text-transform: uppercase;' : '')}
  ${({ block }) => (block ? 'display: inline-block;' : '')}
  ${({ underlined }) => (underlined ? 'text-decoration: underline;' : '')}
`
export const H1 = createTypography(theme.typography.h1)
export const H2 = createTypography(theme.typography.h2)
export const H3 = createTypography(theme.typography.h3)
export const H4 = createTypography(theme.typography.h4)
export const Label = createTypography(theme.typography.label)
export const Menu = createTypography(theme.typography.menu)
export const Body = createTypography(theme.typography.body)
